import { BoosterWagerBonus, UserBonus } from 'config/types/bonus/userBonus'
import React from 'react'
import BonusContentBoostedAmount from '../Common/BonusContentBoostedAmount'
import BonusContentExpiryDate from '../Common/BonusContentExpiryDate'
import BonusItemName from '../Common/BonusItemName'

interface BonusItemProps {
  bonus: UserBonus
}

const SimpleUsedBonusContent: React.FC<BonusItemProps> = ({ bonus }) => {
  return (
    <>
      <BonusItemName bonus={bonus} mb="8px" />
      {bonus instanceof BoosterWagerBonus ? (
        <BonusContentBoostedAmount bonus={bonus} mt="8px" />
      ) : (
        <BonusContentExpiryDate bonus={bonus} my="8px" />
      )}
    </>
  )
}

export default SimpleUsedBonusContent

